import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';

import { Box, Button, Column, Row } from '@chargify/custom-ui-components';
import { useFormatAddress } from '@chargify/address';
import { ShippingAddressModel } from '../../models/customerDetails/types';
import { ConfigContext } from '../../contexts';
import { DetailsRow } from '../DetailsRow';

export type ShippingAddressProps = {
  shippingAddress: ShippingAddressModel;
  onEdit: () => void;
  editAllowed: boolean;
};

const ShippingAddress = ({
  shippingAddress,
  onEdit,
  editAllowed,
}: ShippingAddressProps) => {
  const { t } = useTranslation(['customer-details']);
  const { customerProfile } = useContext(ConfigContext);
  const { customerDataVisibleFields } = customerProfile;
  const { address, address2, city, state, zip, country } =
    useFormatAddress(shippingAddress);

  return (
    <Box>
      <Row>
        {(customerDataVisibleFields.includes('address') ||
          customerDataVisibleFields.includes('address2')) && (
          <DetailsRow
            label={t('shipping_address.street_name_and_number')}
            value={address + ' ' + address2}
          />
        )}
        {customerDataVisibleFields.includes('city') && (
          <DetailsRow label={t('shipping_address.town')} value={city} />
        )}
        {(customerDataVisibleFields.includes('state') ||
          customerDataVisibleFields.includes('zip')) && (
          <DetailsRow
            label={t('shipping_address.state_and_zip_code')}
            value={state + ' ' + zip}
          />
        )}
        {customerDataVisibleFields.includes('country') && (
          <DetailsRow label={t('shipping_address.country')} value={country} />
        )}
        <Column span={24}>
          {editAllowed ? (
            <Button
              onClick={onEdit}
              color={'secondary'}
              iconLeft="edit"
              label={t('shipping_address.edit_shipping_address')}
            />
          ) : null}
        </Column>
      </Row>
    </Box>
  );
};

export default ShippingAddress;
